import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import Checkbox from './inputs/Checkbox'

// Snackbar functionality *** Requires EXTEND!
// import HasSnackbar from './HasSnackbar'

// Material UI
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';
import MuiPhoneNumber from 'material-ui-phone-number'

// Custom Inputs
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import PasswordField from './inputs/PasswordField'
import TextInput from './inputs/TextInput'
import FormSelect from './inputs/FormSelect'
import MetaBox from './inputs/MetaBox'

// Custom Views
import InnerBar from './InnerBar'
import Loader from './Loader'

import {
  is_logged_on,
  extract_errors,
  is_validating
 } from "../helpers"

import {
  LocalForm,
  Control,
  actions
} from 'react-redux-form'

import {
  isRequired,
  // validatePhoneType,
  optionalPasswordLength,
  validatePasswordLength,
  validateEmailType
} from "../validators"

import {
  create_user,
  get_user,
  update_user,
  set_user_errors,
  reset_user,
  clear_user,
  set_path,
  preferences_index,
  lock_user,
  unlock_user,
  resend_invitation,
} from '../actions'

const mapDispatchToProps = dispatch => {
  return {
    getUser: user_id => dispatch( get_user(user_id) ),
    lockUser: user_id => dispatch( lock_user(user_id) ),
    unlockUser: user_id => dispatch( unlock_user(user_id) ),
    resendInvitation: (user_id) => dispatch( resend_invitation(user_id) ),
    setErrors: messages => dispatch( set_user_errors(messages) ),
    updateUser: (id, values) => dispatch( update_user(id, values) ),
    createUser: (values) => dispatch( create_user( values) ),
    setPath: path => dispatch( set_path(path)),
    resetUser: () => dispatch( reset_user() ),
    clearUser: () => dispatch( clear_user() ),
    getPreferences: () => dispatch( preferences_index() )
  };
};

const mapStateToProps = (state) => {
  const { user, genders, ages, educations, industries, must_redirect, errors, fetching_single } = state.user
  return {
    user,
    genders, ages, educations, industries,
    must_redirect, fetching_single,
    errors,
    current_user: state.auth.current_user.data,
    skills: state.skill.items,
    businesses: state.business.items
  };
}

class ConnectedUserForm extends React.Component {
  constructor() {
    super()
    this.state = {
      ...this.state,
      hasLoaded: false,
      emailValid: true,
      emailError: '',
      nameValid: true,
      nameError: '',
      role: '',
      roleValid: true,
      skill: '',
      skillValid: true,
      business: '',
      businessValid: true,
      surnameValid: true,
      surnameError: '',
      phoneValid: true,
      phoneError: '',
      formValid: false,
      formData: null,
      newPasswordValid: true,
      newPasswordError: '',
      passValue: '',
      passConfirmationValid: true,
      passConfirmationError: '',
      phone: '+30',
      mustRedirect: false,
      age: '',
      gender: '',
      industry: '',
      education: ''
    }
  }

  paths = {
    create: "adduser",
    update: "",
    profile: ""
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  handleChangeRole(e) {
    const { value } = e.target
    const { passValue } = this.state
    this.formDispatch(actions.change('user.role', value))
    this.formDispatch(actions.change('user.password', passValue))
    this.setState({role: value, roleValid: ( value && value !== '' )})
  }

  handleChangeSkill(e) {
    const { value } = e.target
    this.formDispatch(actions.change('user.skill', value))
    this.setState({skill: value, skillValid: ( value && value !== '' )})
  }

  handleChangeBusiness(e) {
    const { value } = e.target
    this.formDispatch(actions.change('user.business', value))
    this.setState({business: value, businessValid: ( value && value !== '' )})
  }

  handleChangeGender(e) {
    const { value } = e.target
    this.formDispatch(actions.change('user.gender', value))
    this.setState({gender: value})
  }

  handleChangeAge(e) {
    const { value } = e.target
    this.formDispatch(actions.change('user.age', value))
    this.setState({age: value})
  }

  handleChangeEducation(e) {
    const { value } = e.target
    this.formDispatch(actions.change('user.education', value))
    this.setState({education: value})
  }

  handleChangeIndustry(e) {
    const { value } = e.target
    this.formDispatch(actions.change('user.industry', value))
    this.setState({industry: value})
  }

  handleOnChange(value) {
    this.formDispatch(actions.change('user.phone',value))
    this.setState({phone: value})
  }

  componentWillMount() {
    this.props.resetUser()
    const { user_id, actionName } = this.props
    if ( actionName !== 'profile' ) {
      this.props.getPreferences()
    }
    if ( actionName !== 'create' && user_id ) {
      this.props.getUser(user_id)
    }
    this.props.setPath(this.paths[actionName || ''])
  }

  componentWillUnmount() {
    this.props.clearUser()
  }

  componentDidUpdate(prevProps, prevState){
    const { timestamp, phone, gender, age, industry, education } = this.props.user
    const old_timestamp = prevProps.user.timestamp
    if ( timestamp !== old_timestamp) {
      return this.setState({
        phone: phone || '',
        gender: gender || '',
        age: age || '',
        education: education || '',
        industry: industry || ''
      })
    }

    if (this.props.actionName !== 'profile') {
      if ( this.state.role === '' && this.props.user.role  ) {
        this.setState({ role: this.props.user.role})
      }
      if ( this.state.skill === '' && this.props.user.skill && this.props.user.skill.id ) {
        this.setState({ skill: this.props.user.skill.id })
      }
      if ( this.state.business === '' && this.props.user.business && this.props.user.business.id ) {
        this.setState({ business: this.props.user.business.id })
      }
    }

    const { errors, actionName } = this.props
    const prevErrors = prevProps.errors

    if (actionName === 'create') {
      const emailErrors = extract_errors(errors, "email")
      const prevEmailErrors = extract_errors(prevErrors, "email")

      if (emailErrors && !prevEmailErrors) {
        this.setState({
          emaileValid: false,
          emailError: emailErrors
        })
      }
    }

    const nameErrors = extract_errors(errors, "name")
    const prevNameErrors = extract_errors(prevErrors, "name")

    if (nameErrors && !prevNameErrors) {
      this.setState({
        nameValid: false,
        nameError: nameErrors
      })
    }

    const surnameErrors = extract_errors(errors, "surname")
    const prevSurameErrors = extract_errors(prevErrors, "surname")

    if (surnameErrors && !prevSurameErrors) {
      this.setState({
        surnameValid: false,
        surnameError: surnameErrors
      })
    }

    const phoneErrors = extract_errors(errors, "phone")
    const prevPhoneErrors = extract_errors(prevErrors, "phone")

    if (phoneErrors && !prevPhoneErrors) {
      this.setState({
        phoneValid: false,
        phoneError: phoneErrors
      })
    }

    const passErrors = extract_errors(errors, "password")
    const prevpassErrors = extract_errors(prevErrors, "password")

    if (passErrors && !prevpassErrors) {
      this.setState({
        newPasswordValid: false,
        newPasswordError: passErrors
      })
    }

    const passConfirmationErrors = extract_errors(errors, "password_confirmation")
    const prevpassConfirmationErrors = extract_errors(prevErrors, "password_confirmation")

    if (passConfirmationErrors && !prevpassConfirmationErrors) {
      this.setState({
        passConfirmationValid: false,
        passConfirmationError: passConfirmationErrors
      })
    }

    if (this.props.must_redirect) {
      if (actionName === "profile") {
        window.showSnackbar('success', 'Your profile has been updated.')
      } else if (actionName === "create") {
        window.showSnackbar('success', 'The new user has been created.')

        this.setState({mustRedirect: true})
      } else {
        window.showSnackbar('success', 'User data have been udpated.')
      }
      this.props.resetUser()
    }

    if (!this.state.hasLoaded && prevProps.skills.length !== this.props.skills.length) {
      this.setState({hasLoaded: true})
    }
  }

  checkValid() {
    const { current_user, actionName } = this.props
    if (actionName === 'create') {
      this.formDispatch( actions.setDirty('user.email') )
    }
    this.formDispatch( actions.setDirty('user.name') )
    this.formDispatch( actions.setDirty('user.surname') )
    this.formDispatch( actions.setDirty('user.phone') )
    this.formDispatch( actions.setDirty('user.password') )
    this.formDispatch( actions.setDirty('user.password_confirmation') )

    let roleValid = true
    if (this.state.role === '' && actionName !== 'profile' &&  current_user.role === 'admin') {
      roleValid = false
    }

    if (this.state.role !== 'client' && actionName === 'create') {
      this.formDispatch( actions.change('user.password', this.state.passValue) )
    }

    let phoneValid = true
    if (! /^(\+?\d*(\s*\(\d+\)\s*)?[\d\-]{7,})?$/.test(this.state.phone)) {
      phoneValid = false
      this.formDispatch( actions.change('user.phone', this.state.phone) )
    }

    let skillValid = true
    if (current_user.role === 'admin' && actionName !== 'profile' && this.state.role !== 'user' && this.state.role !== 'admin' && this.state.role !== 'client' && this.state.skill === '') {
      skillValid = false
    }

    let businessValid = true
    if (current_user.role === 'admin' && this.state.role === 'client' && (this.state.business === '' || !this.state.business) ) {
      businessValid = false
    }

    const isValid = this.state.formData.$form.valid && roleValid && skillValid && businessValid && phoneValid
    if (!isValid) {
      window.showSnackbar('error', 'Please fill in all mandatory fields.')
    }

    this.setState({
      roleValid: roleValid,
      skillValid: skillValid,
      businessValid: businessValid,
      phoneValid: phoneValid
    })

    return isValid
  }

  handleSubmit(values) {
    const { user_id, actionName, updateUser, createUser } = this.props
    const {password, password_confirmation, ...other} = values
    const {role} = values
    let newValues
    if ( (actionName === 'create' && role === 'client') || password === undefined || password === null || password === '' ) {
      newValues = {
        ...other
      }
    } else {
      newValues = {
        ...values
      }
    }
    if ( actionName === 'create' ) {
      createUser(newValues)
    } else {
      updateUser(user_id, newValues)
    }
  }

  handleUpdate(form) {

    const { email, name, surname, phone, password, password_confirmation, $form } = form

    this.setState({formData: form})

    const emailState = (this.props.actionName === 'create') ? (email.pristine || email.valid) : true
    const nameState = (name.pristine || name.valid)
    const surnameState = (surname.pristine || surname.valid)
    const phoneState = (phone.pristine || /^(\+?\d*(\s*\(\d+\)\s*)?[\d\-]{7,})?$/.test(phone.value))
    const newPassState = (password.pristine || password.valid)
    const passConfirmationState = (password_confirmation.pristine || (password_confirmation.value === password.value) )

    this.props.setErrors([])

    const formState = $form.valid

    this.setState({
      emailValid: emailState,
      nameValid: nameState,
      surnameValid: surnameState,
      phoneValid: phoneState,
      formValid: formState,
      newPasswordValid: newPassState,
      passConfirmationValid: passConfirmationState,
      passValue: password.value
    })
  }

  roles = {
    "user": "Test Taker",
    "creator": "Data Content Creator",
    "expert": "Skill Expert",
    "client": "B2B User",
    'admin': "Global Administrator",
  }

  actions = {
    'update': "SAVE",
    'create': "SAVE",
    'profile': "UPDATE PROFILE"
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }
    //
    // if (this.props.actionName !== 'profile' && this.props.current_user.role !== 'admin') {
    //   return <Redirect to="/" />
    // }
    const { current_user, user_id, user, actionName, headTitle, ages, genders, industries, educations, fetching_single} = this.props

    if (!is_validating() && fetching_single) {
      return <Loader />
    }

    if ( !this.state.hasLoaded && (is_validating() || fetching_single)) {
      return ''
    }

    if ( current_user.role !== 'admin' && actionName !== "profile") {
      return <Redirect to="/" />
    } else if ( current_user.role !== 'admin' && current_user.id !== user_id ) {
      return <Redirect to="/" />
    }

    if (this.state.mustRedirect) {
      return <Redirect to={`/users/${user.id}/edit`} />
    }

    const { emailValid, nameValid, surnameValid, phoneValid, newPasswordValid, passConfirmationValid, passValue } = this.state
    const {
      id, longid, name, surname, phone, email, skill, business, role, busers,
      locked, active, confirmed, created_at, tests_taken, linkedin, twitter, facebook,
      admin_receive_test_email, admin_receive_feedback_email, admin_receive_b2b_email
     } = user
    const status = (!confirmed) ? 'Not confirmed' : ( active && !locked ) ? 'Active' : ( active && locked  ) ? 'Locked' : 'Blocked'

    if ( actionName !== 'create' && (!name || name === '') ) {
      return ''
    }

    if ( actionName !== 'profile' && this.props.skills.length === 0) {
      return ''
    }

    const actionButton = (
      <CustomOutlinedButton
        size="large"
        type="submit"
        aria-label="Submit"
        className="buttonnoto c-blue align-self-center"
        onClick={e=> {
          e.preventDefault()
          if ( this.checkValid() ) {
            this.formDispatch(actions.submit('user'))
          }
        }}
      >{this.actions[actionName]}</CustomOutlinedButton>
    )

    let initialState
    if (actionName === 'create') {
      initialState = {
        twitter: '', linkedin: '', facebook: facebook || '', email: '', name: name || '',
        surname: surname || '', phone: phone || '', password: '', password_confirmation: ''
      }
    } else {
      initialState = {
        twitter: twitter || '', linkedin: linkedin || '', facebook: facebook || '', name: name || '',
        surname: surname || '', phone: phone || '', password: '', password_confirmation: ''
      }
    }
    if ( actionName === 'profile' && current_user.role === 'admin' ) {
      initialState = {
        ...initialState,
        admin_receive_test_email: admin_receive_test_email || false,
        admin_receive_feedback_email: admin_receive_feedback_email || false,
        admin_receive_b2b_email: admin_receive_b2b_email || false,
      }
    }

    const your = actionName === 'profile' ? ' your ' : ' '
    const fieldWidth = actionName === 'profile' ? 4 : 12

    const state_business = this.state.business
    const state_role = this.state.role
    const state_skill = this.state.skill
    return (

          <Grid container spacing={24}>

            <Grid item xs={12}  md={ actionName === "update" ? 8 : 12} className={actionName === "update" ? "will-change9" : ''}>

              <div className="d-flex justify-content-between mb-40">

                <Typography className="fw-bold h4">{headTitle}</Typography>

                { actionButton }

                </div>
            </Grid>

            <Grid item xs={12} md={ actionName !== "update" ? 12 : 8} className={actionName === "update" ? "will-change9" : ''}>

              <LocalForm
                model="user"
                className="collection-item"
                getDispatch={(dispatch) => this.attachDispatch(dispatch)}
                initialState={initialState}
                onUpdate={(form) => this.handleUpdate(form)}
                onSubmit = {(values) => this.handleSubmit(
                  {
                    ...values,
                    business: state_business,
                    role: state_role,
                    skill: state_skill
                  }
                )}
              >

                  <div className="d-none">{actionButton}</div>

                  <Paper className={`innerbar ${role === 'user' && actionName !== 'profile' ? 'mb-24' : ''}`}>

                    <InnerBar text="Personal Information"/>

                    <div className="pl-24 pr-24 pt-24 pb-24">

                      { actionName === 'profile' && (
                          <div>
                            <div className="mb-12 c-black087 body1">
                              <span className="d-inline-block fw-bold min-width-100">User Name: </span>
                              <span className="c-black087 body1">{email}</span>
                            </div>
                          </div>
                      )}

                      <Grid item xs={12} md={fieldWidth}>

                        { actionName === "profile" && current_user.role !== 'admin' && skill && (
                            <div className="mb-12 c-black087 body1">
                              <span className="d-inline-block fw-bold min-width-100">Skill: </span>
                              <span className="c-black087 body1">{skill.name}</span>
                            </div>
                        )}

                        {
                          actionName === "profile" && (
                            <div className="mb-12 c-black087 body1">
                              <span className="d-inline-block fw-bold min-width-100">Role: </span>
                              <span className="c-black087 body1">{ role ? this.roles[role] : 'User' }</span>
                            </div>
                        )}

                        {
                          actionName === "create" && (
                            <TextInput
                              id="user-email"
                              model="user.email"
                              required
                              placeholder="Email"
                              error={!emailValid}
                              helperText="Enter email for new user (cannot change)"
                              validators={{
                                required: (val) => {
                                  return validateEmailType(val)
                                }
                              }}
                            />
                        )}

                        <TextInput
                          id="user-name"
                          model="user.name"
                          required
                          placeholder="Name"
                          error={!nameValid}
                          helperText={`Enter${your}first name`}
                          validators={{
                            required: (val) => {
                              return isRequired(val)
                            }
                          }}
                        />

                        <TextInput
                          id="user-surname"
                          model="user.surname"
                          required
                          placeholder="Last Name"
                          error={!surnameValid}
                          helperText={`Enter${your}Last Name`}
                          validators={{
                            required: (val) => {
                              return isRequired(val)
                            }
                          }}
                        />

                        {

                          actionName !== 'profile' && (
                            <React.Fragment>

                              <Control.select
                                model="wath"
                                id="user-role"
                                value={this.state.role}
                                label="Select Role *"
                                inputProps= {{className: 'input-pl16'}}
                                component={FormSelect}
                                required
                                error={!this.state.roleValid}
                                helperText={this.state.roleValid ? '' : 'Role is required'}
                                className="w-100 label-pl16"
                                onChange={(e) => this.handleChangeRole(e)}
                                validators={{
                                  required: (val) => {
                                    return isRequired(val)
                                  }
                                }}
                              >
                                {
                                  Object.keys(this.roles).map( r => {
                                    return <MenuItem key={`control-role-${r}`} value={r}>{this.roles[r]}</MenuItem>
                                  })
                                }
                              </Control.select>

                              <Control.select
                                model="wathe"
                                id="user-business"
                                value={this.state.business}
                                label="Select Business *"
                                inputProps= {{className: 'input-pl16'}}
                                disabled={ this.state.role !== 'client' }
                                component={FormSelect}
                                required
                                error={this.state.role === 'client' && !this.state.businessValid}
                                helperText={(this.state.role === 'client' && !this.state.businessValid) ? 'Business is required for B2B users' : ''}
                                className="w-100 label-pl16"
                                onChange={(e) => this.handleChangeBusiness(e)}
                              >
                                <MenuItem value={''} className="blank_selection">Select a business</MenuItem>
                                {
                                  this.props.businesses.map( s => {
                                    return <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                                  })
                                }
                              </Control.select>

                              <Control.select
                                model="wah"
                                id="user-skill"
                                value={(this.state.role === 'user' || this.state.role === 'admin') ? '' : this.state.skill}
                                label="Select Skill"
                                disabled={ (this.state.role !== 'creator' && this.state.role !== 'expert') }
                                inputProps= {{className: 'input-pl16'}}
                                component={FormSelect}
                                error={(this.state.role === 'creator' || this.state.role === 'expert') && !this.state.skillValid}
                                helperText={((this.state.role === 'creator' || this.state.role === 'expert') && !this.state.skillValid) ? 'Skill is required for system users' : ''}
                                className="w-100 label-pl16"
                                onChange={(e) => this.handleChangeSkill(e)}
                              >
                                <MenuItem value={''} className="blank_selection">Select a skill</MenuItem>
                                {
                                  this.props.skills.map( s => {
                                    return <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                                  })
                                }
                              </Control.select>
                            </React.Fragment>
                          )
                        }

                        <MuiPhoneNumber
                          onChange={ this.handleOnChange.bind(this) }
                          error={!phoneValid}
                          value={this.state.phone}
                          label="Phone"
                          helperText={phoneValid ? `Enter${your}Phone Number` : 'Invalid phone format or length'}
                          inputClass="muiPhoneInput"
                          preferredCountries={['gr']}
                          defaultCountry={'gr'}
                          required
                        />

                        <Control
                          id="user-password"
                          model="user.password"
                          component={PasswordField}
                          error={(this.state.role !== 'client') && !newPasswordValid}
                          className="w-100 h-auto"
                          margin="normal"
                          placeholder="Enter new Password"
                          helperText={(this.state.role === 'client' || newPasswordValid) ? 'Enter a new password' :
                            this.state.passwordError || "Password must be at least 7 characters long"
                          }
                          validators={{
                            optional: (val) => {
                              return (actionName === 'create' && this.state.role !== 'client') ?
                              validatePasswordLength(val) :
                              optionalPasswordLength(val, 7)
                            }
                          }}
                        />

                        <Control
                          id="user-password_confirmation"
                          model="user.password_confirmation"
                          component={PasswordField}
                          error={(this.state.role !== 'client') && !passConfirmationValid}
                          className="w-100 h-auto"
                          margin="normal"
                          placeholder="Retype new Password"
                          helperText={(this.state.role === 'client' || passConfirmationValid) ? 'Confirm the new password' :
                            this.state.passConfirmationError || "Password and Confirmation do not match"
                          }
                          validators={{
                            optional: (val) => {
                              return val === passValue
                            }
                          }}
                        />
                      </Grid>
                    </div>

                  </Paper>

                  {
                    actionName === 'profile' && current_user.role === 'admin' && (
                      <Paper className='innerbar mt-24'>

                        <InnerBar text="System Preferences"/>
                        <div className="pl-24 pr-24 pt-24 pb-24">
                          <Grid item xs={12} md={12}>

                            <Control.checkbox
                              id="user-test-email"
                              model="user.admin_receive_test_email"
                              className="c-black087 body1 w-100"
                              label="Receive test results email notifications"
                              color="default"
                              component={Checkbox}
                            />

                            <Control.checkbox
                              id="user-test-feedback"
                              model="user.admin_receive_feedback_email"
                              className="c-black087 body1 w-100"
                              label="Receive feedback email notifications"
                              color="default"
                              component={Checkbox}
                            />

                            <Control.checkbox
                              id="user-b2b-subscribe"
                              model="user.admin_receive_b2b_email"
                              className="c-black087 body1 w-100"
                              label="Receive email notifications for new B2B users"
                              color="default"
                              component={Checkbox}
                            />
                          </Grid>
                        </div>
                      </Paper>
                    )
                  }

                  { role === 'user' && (
                    <React.Fragment>
                      <Paper className="mb-24 innerbar">
                        <InnerBar text="Social Media Information"/>
                        <div className="pl-24 pr-24 pt-24 pb-24">
                          <Grid item xs={12} md={fieldWidth}>

                            <TextInput
                              id="user-linkedin"
                              model="user.linkedin"
                              placeholder="LinkedIn Account"
                              helperText={`LinkedIn Account`}
                            />

                            <TextInput
                              id="user-twitter"
                              model="user.twitter"
                              placeholder="Twitter Account"
                              helperText={`Twitter Account`}
                            />

                            <TextInput
                              id="user-facebook"
                              model="user.facebook"
                              placeholder="Facebook Account"
                              helperText={`Facebook Account`}
                            />

                          </Grid>
                        </div>
                      </Paper>

                      <Paper className="innerbar">
                        <InnerBar text="Demographic Information"/>
                        <div className="pl-24 pr-24 pt-24 pb-24">
                          <Grid item xs={12} md={fieldWidth}>

                            <Control.select
                              model="prgenders"
                              id="user-genders"
                              value={this.state.gender || ''}
                              label="Gender"
                              inputProps= {{className: 'input-pl16'}}
                              component={FormSelect}
                              className="w-100 label-pl16"
                              onChange={(e) => this.handleChangeGender(e)}
                            >
                              {
                                Object.keys(genders).map( value => {
                                  return <MenuItem key={value} value={value}>{genders[value]}</MenuItem>
                                })
                              }
                            </Control.select>

                            <Control.select
                              model="prages"
                              id="user-ages"
                              value={this.state.age || ''}
                              label="Age Range"
                              inputProps= {{className: 'input-pl16'}}
                              component={FormSelect}
                              className="w-100 label-pl16"
                              onChange={(e) => this.handleChangeAge(e)}
                            >
                              {
                                Object.keys(ages).map( value => {
                                  return <MenuItem key={value} value={value}>{ages[value]}</MenuItem>
                                })
                              }
                            </Control.select>

                            <Control.select
                              model="preducations"
                              id="user-educations"
                              value={this.state.education || ''}
                              label="Education"
                              inputProps= {{className: 'input-pl16'}}
                              component={FormSelect}
                              className="w-100 label-pl16"
                              onChange={(e) => this.handleChangeEducation(e)}
                            >
                              {
                                Object.keys(educations).map( value => {
                                  return <MenuItem key={value} value={value}>{educations[value]}</MenuItem>
                                })
                              }
                            </Control.select>

                            <Control.select
                              model="prindustries"
                              id="user-industries"
                              value={this.state.industry || ''}
                              label="Industry"
                              inputProps= {{className: 'input-pl16'}}
                              component={FormSelect}
                              className="w-100 label-pl16"
                              onChange={(e) => this.handleChangeIndustries(e)}
                            >
                              {
                                Object.keys(industries).map( value => {
                                  return <MenuItem key={value} value={value}>{industries[value]}</MenuItem>
                                })
                              }
                            </Control.select>

                          </Grid>
                        </div>
                      </Paper>
                    </React.Fragment>
                  )}

                  <Hidden smDown>
                    <div className="d-flex justify-content-end mt-40">
                      { actionButton }
                    </div>
                  </Hidden>

              </LocalForm>


            </Grid>

            { actionName === "update" && (
              <Grid item xs={12} md={4} className="will-change3">

                <Paper>
                  <div className="bg-white">
                    <div className="pt-24 pb-24 pr-24 pl-24">
                      <div className="mb-12 c-black087 body2">
                        <span className="d-inline-block fw-bold min-width-100">Status:</span>{status}
                      </div>

                      <MetaBox
                        title="Email"
                        value={email}
                      />
                      <MetaBox
                        title="ID"
                        value={id}
                      />
                      <MetaBox
                        title="Created on"
                        value={new Date(created_at).toLocaleString()}
                      />
                      {
                        role === 'user' ? (
                          <MetaBox
                            title="Tests taken"
                            value={tests_taken}
                          />
                        ) : role === 'client' ? (
                          <MetaBox
                            title="Business"
                            value={user.business ? user.business.name : ''}
                          />
                        ) : (
                          <React.Fragment>
                            <MetaBox
                              title="Published Qs"
                              value={user.questions ? user.questions.published : 0}
                            />
                            <MetaBox
                              title="Draft Qs"
                              value={user.questions ? user.questions.draft : 0}
                            />
                            <MetaBox
                              title="Trashed Qs"
                              value={user.questions ? user.questions.trash : 0}
                            />
                          </React.Fragment>
                        )
                      }

                    </div>
                  </div>

                  {
                    (current_user.role === 'admin' && busers.length > 0) && (
                      <React.Fragment>
                        <Divider className="bg-divider" />

                        <div className="bg-white">
                          <div className="pt-24 pb-24 pr-24 pl-24">

                          { busers.map( b => {
                            return <MetaBox
                              key={b.business_id}
                              title="B2B User"
                              value={b.business_name}
                            />
                          })}

                          </div>
                        </div>
                      </React.Fragment>
                    )
                  }

                  <Divider className="bg-divider" />

                  <div className="bg-white">
                    <div className="pt-24 pb-24 pr-24 pl-24">
                    <div className="fw-bold body2">Actions:</div>
                      { confirmed && active && !locked && (
                        <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=>{
                            e.preventDefault()
                            this.props.lockUser(id)
                        }}>Block Access</Link>
                      )}

                      { confirmed && active && locked && (
                        <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=>{
                            e.preventDefault()
                            this.props.unlockUser(id)
                        }}>Unlock</Link>
                      )}

                      { !confirmed && (
                        <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=>{
                            e.preventDefault()
                            this.props.resendInvitation(id)
                        }}>Resend Invitation</Link>
                      )}

                      { !active && locked && (
                        <Link className="c-black087 body2 d-block mb-8" to='' onClick={e=>{
                            e.preventDefault()
                            this.props.unlockUser(id)
                        }}>Reactivate User</Link>
                      )}

                      {
                        role === 'user' && tests_taken !== undefined && tests_taken > 0 && (
                          <Link to={`/tests/user?user=${email}`} className="c-black087 body2 d-block mb-8" target="_blank">
                            Tests Taken
                          </Link>
                        )
                      }

                      {
                        role !== 'user' && user.questions && user.questions.total !== undefined && user.questions.total > 0 && (
                          <Link to={`/questions/user?user=${longid}`} className="c-black087 body2 d-block mb-8" title="User Questions" target="_blank">
                            Go to Questions
                          </Link>
                        )
                      }

                    </div>
                  </div>
                </Paper>
              </Grid>
            )}

          </Grid>

    )
  }
}

const UserForm = connect(mapStateToProps, mapDispatchToProps)(ConnectedUserForm);

export default UserForm



// WEBPACK FOOTER //
// ./src/js/components/UserForm.js